// component/FiltrerBusinessModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  FormGroup,
  Input,
  ButtonGroup,
} from "reactstrap";
import "../utils/detail.css";

const FiltrerBusinessModal = ({
  isOpen,
  toggle,
  onApply,
  countries = [],
}) => {
  // STATUS
  const [isActive, setIsActive] = useState(null);

  // COUNTRY
  const [selectedCountry, setSelectedCountry] = useState("");

  // DATE DEMANDE
  const [requestDateFrom, setRequestDateFrom] = useState("");
  const [requestDateTo, setRequestDateTo] = useState("");

  // DATE APPROBATION
  const [approvalDateFrom, setApprovalDateFrom] = useState("");
  const [approvalDateTo, setApprovalDateTo] = useState("");

  // TRI
  const [sort, setSort] = useState("desc");

  // APPLY FILTERS
  const applyFilters = () => {
    onApply({
      isActive,
      country: selectedCountry,
      requestDateFrom,
      requestDateTo,
      approvalDateFrom,
      approvalDateTo,
      sort,
    });
  };

  // RESET
  const resetFilters = () => {
    setIsActive(null);
    setSelectedCountry("");
    setRequestDateFrom("");
    setRequestDateTo("");
    setApprovalDateFrom("");
    setApprovalDateTo("");
    setSort("desc");
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      contentClassName="custom-modal-siz-business"
      centered
    >
      <ModalHeader toggle={toggle}>Filtrer</ModalHeader>

      <ModalBody>

        {/* ================= STATUS ================= */}
        <div className="mb-3">
          <label>Statut</label>

            <ButtonGroup>
   <Button
  style={{
    backgroundColor: isActive === "" ? "#3761FF14" : "#0000000F",
    color: isActive === "" ? "#3761FF" : "#000000",
    border:isActive===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: isActive === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setIsActive(null)}
>
  Tous
</Button>

    <Button
     style={{
        backgroundColor: isActive === true ? "#EBFFEA" : "#0000000F",
        color: isActive === true ? "#349C32" : "#000000",
        border:isActive === true ? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: isActive === true ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setIsActive(true)}
    >
      Activé
    </Button>

    <Button
     style={{
        backgroundColor: isActive === false ? "#FFF0F0" : "#0000000F",
        color: isActive === false ? "#E32727" : "#000000",
        border:isActive===false ? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: isActive === false ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setIsActive(false)}
    >
      Désactivé
    </Button>
  </ButtonGroup>
        </div>

        {/* ================= COUNTRY ================= */}
        <div className="mb-3">
          <label>Pays</label>

          <FormGroup>
            <Input
              type="select"
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <option value="">Tous</option>

              {countries.map((c, i) => (
                <option key={i} value={c}>
                  {c}
                </option>
              ))}
            </Input>
          </FormGroup>
        </div>

        {/* ================= REQUEST DATE ================= */}
        <div className="mb-3">
          <label>Date de demande</label>

          <Input
            type="date"
            value={requestDateFrom}
            onChange={(e) => setRequestDateFrom(e.target.value)}
          />

          <Input
            type="date"
            value={requestDateTo}
            onChange={(e) => setRequestDateTo(e.target.value)}
            className="mt-2"
          />
        </div>

        {/* ================= APPROVAL DATE ================= */}
        <div className="mb-3">
          <label>Date d'approbation</label>

          <Input
            type="date"
            value={approvalDateFrom}
            onChange={(e) => setApprovalDateFrom(e.target.value)}
          />

          <Input
            type="date"
            value={approvalDateTo}
            onChange={(e) => setApprovalDateTo(e.target.value)}
            className="mt-2"
          />
        </div>

        {/* ================= ACTIONS ================= */}
        <div className="d-flex justify-content-between mt-4">

          <Button color="secondary" onClick={resetFilters}>
            Réinitialiser
          </Button>

          <Button color="primary" onClick={applyFilters}>
            Appliquer le filtre
          </Button>

        </div>

      </ModalBody>
    </Modal>
  );
};

export default FiltrerBusinessModal;